<template>
		  <!-- <li class="izk-course-new">
                <div class="izk-course-info" v-bind:class="{'disabled': course.sub_status}">
                    <div  class="info-con" @click='goDetail'>
                        <h4 class="title te2"><span class="newtag">春季上新</span>{{course.title}}</h4>
                        <p class="info"><i class="ico-course-time">{{course.course_begin_datetime}}-{{course.course_end_datetime}}</i></p>
                        <p class="info"><i class="ico-course-place">{{course.school_info.name}}</i>></p>
                    </div>
                    <div class="reserve cbox">
                        <div class="flex">
                            <span class="times">{{course.totalNum}}次课</span>
                            <span class="num">{{course.buyNum}}人已预约</span>
                        </div>
                        <span class="g-btn3" v-if="course.sub_status">已预约</span>
                        <a href="javascript:void(0)" class="g-btn3" v-if="!course.sub_status" @click="order">立即预约</a>
                    </div>
                </div>
            </li> -->
            <li class="izk-course-new">
                <div class="card-pic">
                    <img :src="course.picture_url" :alt="course.title" @click='goDetail'>
                    <span class="g-btn3" v-if="course.sub_status">已预约</span>
                        <a href="javascript:void(0)" class="g-btn3" v-if="!course.sub_status" @click="order">立即预约</a>
                </div>
            </li>
	</div>
</template>
<script>
	export default{
	  name: 'OnePicture',
	  props: {
	    course: {
	      type: Object,
	      default: {},
	      required: true
	    }
	  },
	  data(){
	    return {

	    }
	  },
  methods: {
    order(){
      this.$emit('order', this.course);
    },
    goDetail(){
      this.$emit('goDetail', this.course);
    }
  },
	  created(){

	  }
	}
</script>


// WEBPACK FOOTER //
// src/components/courseCenter/one/public/Picture.vue